import type { IgnoreModifier } from '@apollo/client/cache'

import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'
import { useTypedMutation } from '~publish/hooks/useTypedMutation'

const UpdateFeed = graphql(/* GraphQL */ `
  mutation UpdateFeed($input: UpdateFeedInput!) {
    updateFeed(input: $input) {
      __typename
      ... on FeedActionSuccess {
        feed {
          __typename
          id
          name
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useUpdateFeed = () =>
  useTypedMutation(UpdateFeed, (data) => data.updateFeed, {
    successTypename: 'FeedActionSuccess',
    optimisticResponse: (
      variables,
      { IGNORE },
    ): ResultOf<typeof UpdateFeed> | IgnoreModifier => {
      const { id, name } = variables.input
      if (!id || !name) {
        return IGNORE
      }

      return {
        updateFeed: {
          __typename: 'FeedActionSuccess',
          feed: {
            __typename: 'Feed',
            id,
            name,
          },
        },
      }
    },
  })
